import { Injectable } from '@angular/core';
import { TextZoom } from '@capacitor/text-zoom';

@Injectable({
  providedIn: 'root',
})
export class MobileAccessibilityService {
  public async usePreferredTextZoom(usePreferred: boolean) {
    let textZoom = 1;

    if (usePreferred) {
      const prefferedZoom = await TextZoom.getPreferred();

      textZoom = prefferedZoom.value;
    }

    await TextZoom.set({
      value: textZoom,
    });
  }
}
